import login from './login/login'
import logout from './logout/logout'
import refresh from './refresh/refresh'
import register from './register/register'
import mfa from './mfa/mfa'
import forgotPassword from './forgotPassword/forgotPassword.ts'
import resetPassword from './resetPassword/resetPassword.ts'
import verifyTermsOfServices from './verifyTermsOfServices/verifyTermsOfServices.ts'

export default {
  login,
  register,
  logout,
  refresh,
  mfa,
  forgotPassword,
  resetPassword,
  verifyTermsOfServices
}
